var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyState = function SvgEmptyState(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 145,
    viewBox: "0 0 205 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M29.5106 196.997C28.4203 197.174 27.393 196.434 27.2162 195.343L0.320292 29.5101C0.143456 28.4198 0.883983 27.3925 1.97431 27.2157L160.898 1.44047C165.804 0.644712 170.427 3.97709 171.222 8.88354L196.998 167.807C197.175 168.897 196.434 169.924 195.344 170.101L29.5106 196.997Z",
    fill: "#82B1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9933 182.587C19.8924 182.496 19.0733 181.53 19.1637 180.43L32.9153 12.9933C33.0058 11.8925 33.9715 11.0733 35.0723 11.1637L161.646 21.5593C185.315 23.5032 202.926 44.2662 200.982 67.9348L190.587 194.509C190.496 195.609 189.53 196.429 188.43 196.338L20.9933 182.587Z",
    fill: "#F1F9FE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M166.018 66.0668C161.064 65.6599 157.378 61.3142 157.785 56.3603L160.489 23.4267C160.578 22.3503 161.522 21.5494 162.598 21.6378V21.6378C185.741 23.5385 202.961 43.8401 201.06 66.9827V66.9827C200.972 68.0591 200.028 68.86 198.951 68.7716L166.018 66.0668Z",
    fill: "#82B1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.3307,
    y: 82.2246,
    width: 112,
    height: 10,
    rx: 5,
    transform: "rotate(4.6952 57.3307 82.2246)",
    fill: "#82B1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.5299,
    y: 104.15,
    width: 61,
    height: 10,
    rx: 5,
    transform: "rotate(4.6952 55.5299 104.15)",
    fill: "#82B1FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.7291,
    y: 126.076,
    width: 112,
    height: 10,
    rx: 5,
    transform: "rotate(4.6952 53.7291 126.076)",
    fill: "#82B1FF"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyState);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-state.3e01e1feb75dd9a6d541a7a3556b8944.svg";